import { render, staticRenderFns } from "./PassDialog.vue?vue&type=template&id=71b0f49c&scoped=true&"
import script from "./PassDialog.vue?vue&type=script&lang=js&"
export * from "./PassDialog.vue?vue&type=script&lang=js&"
import style0 from "./PassDialog.vue?vue&type=style&index=0&id=71b0f49c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b0f49c",
  null
  
)

export default component.exports